import styles from './styles.module.css';
export function useColor(color = 'inherit') {
    return styles[color];
}
export function useBackgroundColor(color = 'inherit') {
    return styles[`bg-${color}`];
}
